/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var source = _interopDefault(require('./source'));
var consts = require('../ol-ext/consts');

/**
 * @vueProps
 */
var props = {
  crossOrigin: String,
  projection: {
    type: String,
    default: consts.EPSG_3857
  }

  /**
   * @vueMethods
   */
};var methods = {
  /**
   * @return {Promise}
   * @protected
   */
  init: function init() {
    return source.methods.init.call(this);
  },

  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit: function deinit() {
    return source.methods.deinit.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    source.methods.mount.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    source.methods.unmount.call(this);
  }
};

/**
 * @vueProto
 * @alias module:mixin/image-source
 */
var imageSource = {
  mixins: [source],
  props: props,
  methods: methods
};

module.exports = imageSource;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/image-source.js
// module id = 516
// module chunks = 1